module.exports = __webpack_public_path__ + "img/14.ecc2d461.jpg";